module.exports = {"linkMap":{"intro":{"text":"公司簡介","link":"/intro"},"team":{"text":"專業團隊","link":"/team"},"case":{"text":"工程實績","link":"/case"},"contact":{"text":"聯絡我們","link":"/contact"}},"langList":[{"text":"EN","locale":"en"}],"address":"臺北市內湖區民權東路六段21巷31號五樓","tel":"","email":"min.teai@msa.hinet.net","comName":"敏泰資訊, Inc","sexyoung":"寫詩羊資訊"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/locale/zh.json
// module id = 570
// module chunks = 0